/* unplugin-vue-components disabled */import { render } from "./ReleaseItem.vue?vue&type=template&id=f1286ec0&scoped=true&ts=true"
import script from "./ReleaseItem.vue?vue&type=script&lang=ts"
export * from "./ReleaseItem.vue?vue&type=script&lang=ts"

import "./ReleaseItem.vue?vue&type=style&index=0&id=f1286ec0&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1286ec0"]])

export default __exports__